import React from "react";

const ThemeContext = React.createContext({
    // team: 'SEA',
    setTeam: () => { },
});

export default ThemeContext